import React, { Component } from 'react';
import PreLoaderWidget from '../../../components/Loader';
import Notificacao from '../../../components/Notificacao';
import InputIcon from '../../../gb-components/InputIcon';
import Loading from '../../../components/Loading';

import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from '../../../helpers/firebase-config';

import { setReceita } from '../../../Libs/paciente';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { openReceita } from '../../../Libs/Docs.js';
//import PrintComp from './printComponent';
import IconPill from '../../../assets/svg/ic-medicine-pill.svg';
import IconList from '../../../assets/svg/ic-actions-list-add.svg';
import ModalEnvio from "../../../gb-components/ModalEnvio";
import Autocomplete from '@mui/material/Autocomplete';
import algoliasearch from 'algoliasearch/lite';

const searchClient = algoliasearch(
  'S4T1I4OXWN',
  '01bed30f13ef39976e5b4204eba41be4'
);
var timer;

export default class CadastrarReceita extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      id: '',
      remedio_1: '',
      prescricao_1: '',
      remedio_2: '',
      prescricao_2: '',
      remedio_3: '',
      prescricao_3: '',
      remedio_4: '',
      prescricao_4: '',
      sending: false,
      isVisibleSend: false,
      emailSend: '',
      telefonesSend: '',
      dcc: null,
      modoInner: false,
      modoModal: false,
      loadingComplete: false,
      autoCompleteOpt: [],
    };

    this.abrirReceita = this.abrirReceita.bind(this);
  }



  componentDidMount = () => {
    const id = this.props && this.props.match && this.props.match.params && this.props.match.params.id ? this.props.match.params.id : this.props.id;

    this.setState({ modoInner: this.props.id && this.props.id != '' ? true : false });

    let refPaciente = Libfirebase.collection("paciente").doc(id);

    refPaciente.get().then(pac => {
      let telefones = pac.data().telefones;

      // SE TIVER WHATSAPP ELE VAI SER PRIORIDADE
      if (pac.data().whatsapp) {
        telefones = pac.data().whatsapp
      }

      try {
        if (telefones && typeof (telefones) == 'string' && telefones != '') {
          telefones = telefones.replaceAll('-', '').replaceAll(' ', '').replacell('(', '').replaceAll(')', '');
        } else {
          telefones = "";
        }
      } catch (e) {

      }
      this.setState({ emailSend: pac.data().email, telefonesSend: telefones, modoModal: this.props.modoModal });
    });
    this.setState({ id });
  };

  _setCadastro = async () => {
    this.setState({ loading: true });
    const {
      remedio_1,
      prescricao_1,
      remedio_2,
      prescricao_2,
      remedio_3,
      prescricao_3,
      remedio_4,
      prescricao_4,
      id
    } = this.state;

    const user = firebaseAuth.currentUser;

    //valida os campos
    if (
      (remedio_1 !== '' && prescricao_1 !== '') ||
      (remedio_2 !== '' && prescricao_2 !== '') ||
      (remedio_3 !== '' && prescricao_3 !== '') ||
      (remedio_4 !== '' && prescricao_4 !== '')
    ) {
      let idProfissional = 0;
      await Libfirebase
        .collection('usuario')
        .where('email', '==', user.email)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            if (doc.exists) {
              idProfissional = doc.id;
            } else {
            }
          });
        })
        .catch(erro => console.log(erro));



      const refProfissional = Libfirebase
        .collection('usuario')
        .doc(idProfissional);

      const data = {
        remedio_1,
        prescricao_1,
        remedio_2,
        prescricao_2,
        remedio_3,
        prescricao_3,
        remedio_4,
        prescricao_4,
        DataCriacao: moment().format('DD-MM-YYYY'),

        Hora: moment().format('HH:mm:ss'),
        Date: new Date(),
        refProfissional,
        avulsa: this.state.modoInner
      };


      setReceita(data, id)
        .then(dcc => {
          this.setState({ dcc });
          this.setState({ isVisibleSend: true });
        })
        .catch(erro => {
          this.setState({
            loading: false,
            notifition: true,
            msg: erro.code,
            nameclass: 'alert-danger'
          });
        });
    } else {
      this.setState({
        loading: false,
        notifition: true,
        msg: 'Favor entrar com pelo menos uma receita.',
        nameclass: 'alert-danger'
      });
    }
  };

  close() {
    this.setState({ isVisibleSend: false });
    if (this.state.modoInner && this.props.close) {
      this.props.close();
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  abrirReceita(tipo) {
    openReceita(this.state.id, this.state.dcc.id, tipo);
  }

  async handleSearch(text) {
    console.log("passou no serach")
    this.setState({ loadingComplete: true })
    let medicamentos = [];
    if (text !== "") {
      medicamentos = await new Promise((resolve) => {
        clearTimeout(timer);

        timer = setTimeout(async () => {
          const index = searchClient.initIndex("medicamentos");

          let listMeds = []
          let meds = await new Promise(function (resolve, reject) {
            index
              .search(text).then(({ hits }) => {
                hits.forEach(h => {
                  let data = {
                    ref: Libfirebase.doc(h.path),
                    id: h.objectID,
                    ...h
                  };

                  listMeds.push(data)
                });
                resolve(listMeds)
              }).catch(err => {
                console.log(err);
                reject(err)
              });
          })
          console.log("meds", meds)
          let items = meds.map(
            (res, i) => {
              return `${res.nome} - ${res.principio_ativo ? res.principio_ativo : ""}`
            }
          )
          resolve(items)

        }, 1000);
      });
    }


    this.setState({
      autoCompleteOpt: medicamentos,
      loadingComplete: false
    })
    console.log(text)
  }


  render() {
    return (
      <div className="p-3">
        <Loading loading={this.state.loading} />
        {/* 
        <PrintComp
          id={this.state.id}
          dcc={this.state.dcc}
          isVisibleSend={this.state.isVisibleSend}
          modoInner={this.state.modoInner} close={() => { this.close() }}
          history={this.props.history}
          emailSend={this.state.emailSend}
          telefonesSend={this.state.telefonesSend}
          onClose={this.props.onClose}
        /> */}

        {(this.state.dcc) ?
          <ModalEnvio
            visible={this.state.isVisibleSend}
            close={() => { this.setState({ isVisibleSend: false }); this.close() }}
            pacienteId={this.state.id}
            card={'receita'}
            docId={this.state.dcc.id}
            email={this.state.emailSend}
            telefone={this.state.telefonesSend}
            visualizar={this.abrirReceita}
          /> : null}

        {/* <div className="page-wrapper">
          <div className="page-breadcrumb">
            {!this.state.modoInner ? (
              <Link
                to={'/paciente/historico/' + this.state.id}
                className="btn btn-outline-info btn-rounded"
              >
                <i className="fa fa-angle-left" /> Voltar
              </Link>
            ) : null}
            <br />
            <br /> */}
        {this.state.notifition ? (
          <Notificacao
            msg={this.state.msg}
            nameclass={this.state.nameclass}
          />
        ) : null}

        <form>
          <Row>
            <Col xs={12} md={6}>
              <Autocomplete
                loading={this.state.loadingComplete}
                options={this.state.autoCompleteOpt}
                onSelect={val => {
                  this.setState({ remedio_1: val.target.value })
                  this.handleSearch(val.target.value)
                }}
                value={this.state.remedio_1}
                renderInput={(params) =>
                  <div ref={params.InputProps.ref}>
                    <InputIcon
                      placeholder="Remedio 01"
                      type="text"
                      id="remedio_1"
                      onChange={val => {
                        this.setState({ remedio_1: val.target.value })
                      }}
                      icon={IconPill}
                      style={{ width: '100%', marginBottom: 15 }}
                      autoCompleteProps={params.inputProps}
                    />
                  </div>
                }
              />

              <InputIcon
                placeholder="Prescrição 01"
                type="text"
                id="prescricao_1"
                value={this.state.prescricao_1}
                onChange={text => this.setState({ prescricao_1: text })}
                icon={IconList}
                style={{ width: '100%' }}
              />
            </Col>

            <Col xs={12} md={6}>
              <Autocomplete
                loading={this.state.loadingComplete}
                options={this.state.autoCompleteOpt}
                onSelect={val => {
                  this.setState({ remedio_2: val.target.value })
                  this.handleSearch(val.target.value)
                }}
                value={this.state.remedio_2}
                renderInput={(params) =>
                  <div ref={params.InputProps.ref}>
                    <InputIcon
                      placeholder="Remédio 02"
                      type="text"
                      id="remedio_2"
                      onChange={val => {
                        this.setState({ remedio_2: val.target.value })
                      }}
                      icon={IconPill}
                      style={{ width: '100%', marginBottom: 15 }}
                      autoCompleteProps={params.inputProps}
                    />
                  </div>
                }
              />
              <InputIcon
                placeholder="Prescrição 02"
                type="text"
                id="prescricao_2"
                value={this.state.prescricao_2}
                onChange={text => this.setState({ prescricao_2: text })}
                icon={IconList}
                style={{ width: '100%' }}
              />
            </Col>
          </Row>

          <div className="gb-divider"><div className="line"></div></div>

          <Row>
            <Col xs={12} md={6}>
              <Autocomplete
                loading={this.state.loadingComplete}
                options={this.state.autoCompleteOpt}
                onSelect={val => {
                  console.log("remedio3", val.target.value)
                  this.setState({ remedio_3: val.target.value })
                  this.handleSearch(val.target.value)
                }}
                value={this.state.remedio_3}
                renderInput={(params) =>
                  <div ref={params.InputProps.ref}>
                    <InputIcon
                      placeholder="Remédio 03"
                      type="text"
                      id="remedio_3"
                      icon={IconPill}
                      style={{ width: '100%', marginBottom: 15 }}
                      autoCompleteProps={params.inputProps}
                      onChange={val => {
                        console.log("remedio3", val.target.value)
                        this.setState({ remedio_3: val.target.value })
                      }}
                    />
                  </div>
                }
              />
              <InputIcon
                placeholder="Prescrição 03"
                type="text"
                id="prescricao_3"
                value={this.state.prescricao_3}
                onChange={text => this.setState({ prescricao_3: text })}
                icon={IconList}
                style={{ width: '100%' }}
              />
            </Col>
            <Col xs={12} md={6}>
              <Autocomplete
                loading={this.state.loadingComplete}
                options={this.state.autoCompleteOpt}

                /* onBlur={val => {
                  console.log("val.target.value", val.target.value)
                  this.setState({ remedio_4: val.target.value })

                }} */
                onSelect={val => {
                  // console.log("val.target.value", val.target.value)
                  this.setState({ remedio_4: val.target.value })
                  this.handleSearch(val.target.value)
                }}
                value={this.state.remedio_4}
                renderInput={(params) =>
                  <div ref={params.InputProps.ref}>
                    <InputIcon
                      placeholder="Remédio 04"
                      type="text"
                      id="remedio_4"
                      icon={IconPill}
                      style={{ width: '100%', marginBottom: 15 }}
                      autoCompleteProps={params.inputProps}
                      onChange={val => {
                        this.setState({ remedio_4: val.target.value })
                      }}
                    />
                  </div>
                }
              />
              <InputIcon
                placeholder="Prescrição 04"
                type="text"
                id="prescricao_4"
                value={this.state.prescricao_4}
                onChange={text => this.setState({ prescricao_4: text })}
                icon={IconList}
                style={{ width: '100%' }}
              />
            </Col>
          </Row>


          <div className="mt-3">
            <div>{this.state.loading ? (<PreLoaderWidget></PreLoaderWidget>) : <button
              type="button"
              onClick={() => this._setCadastro()}
              className="btn gb-button to-form right"
              disabled={this.state.loading}
            >
              Salvar
            </button>}</div>

          </div>

        </form>
      </div>
    );
  }
}
